import { Button, HelpButton, Logo } from '@kanda-libs/ks-design-library';

import Container from './MobileHeader-container';
import { CLASS_NAMES } from './constants';

import trustPilotImage from '../../assets/trustpilot.png';

export interface MobileHeaderProps {
  showTrustPilot?: boolean;
  showCloseButton?: boolean;
}

const MobileHeader = ({
  showTrustPilot = true,
  showCloseButton = false,
}: MobileHeaderProps) => (
  <Container>
    {({ onClick, showHelpModal }) => (
      <div className={CLASS_NAMES.outerWrapper}>
        <div
          className={
            showTrustPilot
              ? CLASS_NAMES.wrapper
              : CLASS_NAMES.wrapperNoTrustPilot
          }
        >
          <div className={CLASS_NAMES.logoWrapper}>
            <Logo />
          </div>
          {showTrustPilot && (
            <img
              src={trustPilotImage}
              alt="Trust pilot, 4.8 stars, 300+ reviews"
              className={CLASS_NAMES.trustPilot}
            />
          )}
        </div>
        {showCloseButton && (
          <div className={CLASS_NAMES.close}>
            <Button.Icon id="bacs-close" icon="close" onClick={onClick} />
          </div>
        )}
        <div className={CLASS_NAMES.help}>
          <HelpButton onClick={showHelpModal} />
        </div>
      </div>
    )}
  </Container>
);

MobileHeader.displayName = 'MobileHeader-view';

export default MobileHeader;
